export enum Sorting {
  asc = 'asc',
  desc = 'desc',
}
